import React from 'react';
import { Link } from 'react-router-dom';
import { BsKanban } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import StatusBadge from './components/StatusBadge';
import EmptyState from './components/EmptyState';
import { formatDate } from '../../utils/api';

const ESTADO_LABEL = { a_la_espera: 'A la espera', en_proceso: 'En proceso', finalizado: 'Finalizado' };

const CustomerProjectsPage = () => {
  const { projects, loading } = useCustomer();

  if (loading) {
    return (
      <div>
        <div className="cp-skeleton cp-skeleton-title" />
        <div className="cp-skeleton cp-skeleton-card" style={{ height: 300 }} />
      </div>
    );
  }

  return (
    <div>
      <h1 className="cp-page-title">Proyectos</h1>

      {!projects.length ? (
        <EmptyState icon={BsKanban} title="Sin proyectos" subtitle="Aún no tienes proyectos registrados." />
      ) : (
        <div className="cp-card-static">
          <div style={{ overflowX: 'auto' }}>
            <table className="cp-table">
              <thead>
                <tr>
                  <th>Proyecto</th>
                  <th>Estado</th>
                  <th>Progreso</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((p) => {
                  const tot = Number(p.tareas_visibles) || 0;
                  const hecho = Number(p.tareas_hechas) || 0;
                  const pc = tot ? Math.round((hecho / tot) * 100) : 0;
                  return (
                    <tr key={p.id}>
                      <td style={{ fontWeight: 500 }}>
                        <Link to={`/cliente/proyectos/${p.id}`} style={{ color: 'var(--cp-accent)', textDecoration: 'none', fontWeight: 600 }}>{p.titulo}</Link>
                      </td>
                      <td><StatusBadge status={ESTADO_LABEL[p.estado] || p.estado || '-'} /></td>
                      <td style={{ minWidth: 130 }}>
                        {tot > 0 ? (
                          <>
                            <div style={{ fontSize: '0.78rem', color: 'var(--cp-muted)', marginBottom: 3 }}>{hecho}/{tot} · {pc}%</div>
                            <div style={{ height: 6, borderRadius: 999, background: '#eceff3', overflow: 'hidden' }}>
                              <div style={{ width: `${pc}%`, height: '100%', background: 'linear-gradient(90deg,#50BAFC,#2E9BE0)' }} />
                            </div>
                          </>
                        ) : <span style={{ color: 'var(--cp-muted)' }}>—</span>}
                      </td>
                      <td>{formatDate(p.fecha_inicio)}</td>
                      <td>{p.fecha_fin ? formatDate(p.fecha_fin) : (p.estado === 'en_proceso' ? 'En curso' : '-')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerProjectsPage;
